export enum Routes {
  DASHBOARD = '/dashboard',
  LEADERBOARD = '/leaderboard',
  BREAKDOWN = '/breakdown',
  SCORECARD = '/scorecard',
  GLOSSARY = '/glossary',
}
